export { ContentCard, type ContentCardProps } from "./ContentCard";
